// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__8my04","footer":"ChangeClinic_footer__ANj1k"};